var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.2499 22.4998C5.04745 22.4998 0 17.4536 0 11.2499C0 5.04745 5.04745 0 11.2499 0C17.4536 0 22.4998 5.04745 22.4998 11.2499C22.4998 17.4536 17.4536 22.4998 11.2499 22.4998ZM11.2499 2.49997C6.42493 2.49997 2.49997 6.42493 2.49997 11.2499C2.49997 16.0748 6.42493 19.9998 11.2499 19.9998C16.0748 19.9998 19.9998 16.0748 19.9998 11.2499C19.9998 6.42493 16.0748 2.49997 11.2499 2.49997ZM28.7497 29.9997C28.4297 29.9997 28.1097 29.8772 27.866 29.6334L17.8661 19.6335C17.3773 19.1448 17.3773 18.3548 17.8661 17.8661C18.3548 17.3773 19.1448 17.3773 19.6335 17.8661L29.6334 27.866C30.1222 28.3547 30.1222 29.1447 29.6334 29.6334C29.3897 29.8772 29.0697 29.9997 28.7497 29.9997Z","fill":"#3E1052"}));
}

SearchIcon.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
